import React from "react";

type Props = {
  viewMode: "grid" | "list";
  setViewMode: (mode: "grid" | "list") => void;
};

export const ViewModeToggle: React.FC<Props> = ({ viewMode, setViewMode }) => (
  <div className="inline-flex rounded-lg border border-gray-300 dark:border-gray-600 overflow-hidden">
    <button
      type="button"
      onClick={() => setViewMode("grid")}
      className={`px-3 py-2 text-sm ${
        viewMode === "grid"
          ? "bg-primary-700 text-white"
          : "bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600"
      }`}
      title="Vista griglia"
    >
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
      </svg>
    </button>
    <button
      type="button"
      onClick={() => setViewMode("list")}
      className={`px-3 py-2 text-sm ${
        viewMode === "list"
          ? "bg-primary-700 text-white"
          : "bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600"
      }`}
      title="Vista lista"
    >
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
      </svg>
    </button>
  </div>
);
